import moment from 'moment';
import { SignUpType } from './types';

export const initialSignUpFormValues: SignUpType = {
  name: '',
  email: '',
  phone: '',
  username: '',
  displayName: '',
  password: '',
  passwordVerification: '',
  accountType: 'fan',
  birthday: moment().subtract(16, 'years').format('MM/DD/YYYY'),
  region: 'CA',
};
